<template>
  <v-container fluid>
    <v-row align="end" justify="space-around">
      <transition name="carder">
        <v-card v-if="visible" class="mx-auto" max-width="260" outlined>
          <v-list-item three-line>
            <v-list-item-avatar tile size="60">
              <v-icon x-large>fas fa-plane</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <div class="overline mb-2">Procedure Status</div>
              <v-list-item-title class="headline mb-1">{{items[0].value}}</v-list-item-title>
              <v-list-item-subtitle>Set Up Cockpit</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </transition>

      <transition name="carder">
        <v-card v-if="mobile" class="mx-auto" max-width="260" outlined>
          <v-list-item three-line>
            <v-list-item-avatar tile size="60">
              <v-icon x-large>fas fa-tablet-alt</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <div class="overline mb-2">Asset Status</div>
              <transition name="fade">
                <v-list-item-title class="headline mb-1">{{items[1].value}}</v-list-item-title>
              </transition>
              <v-list-item-subtitle>Initialize System</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </transition>

      <transition name="carder">
        <v-card v-if="mobile" class="mx-auto" max-width="260" outlined>
          <v-list-item three-line>
            <v-list-item-avatar tile size="60">
              <v-icon x-large>fas fa-satellite-dish</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <div class="overline mb-2">Network Status</div>
              <v-list-item-title class="headline mb-1">{{items[2].value}}</v-list-item-title>
              <v-list-item-subtitle>Establish Connection</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </transition>
    </v-row>
  </v-container>
</template>

<script>
import {settings} from "../config";

export default {
  data() {
    return {
      items: [
        { value: 0, summer: 3 },
        { value: 0, summer: 1 },
        { value: 0, summer: 0.74 }
      ],
      visible: false
    };
  },
  props: {
    counting: Boolean
  },
  computed: {
    mobile: function() {
      return this.visible && window.innerWidth > 800;
    }
  },
  mounted() {
    this.visible = true; //bring in the loading cards
    //start sensless counting
    let interval = setInterval(() => {
      this.items.forEach(content => {
        content.value =
          Math.floor((content.value + content.summer) * 100) / 100;
      });
      //stop if state chenges
      if (!this.counting) {

        console.log('counting is false')

        clearInterval(interval);
        this.items.forEach(content => {
          content.value = "DONE";
        });
        setTimeout(() => {
          console.log('visible is false')
          this.visible = false;
        }, settings.DELAY_LOADING_SCREEN_COCKPIT * 0.5);
      }
    }, 100);
  }
};
</script>

<style scoped>
.carder-enter-active {
  transition: all 0.3s ease-out;
}

.carder-enter {
  transform: translateY(200px);
}

.carder-leave-to {
  opacity: 0;
}

.carder-leave-active {
  transition: opacity 0.5s ease-out;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.05s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>